const styles = theme => ({
  "@keyframes timerAnimation": {
    from: {
      width: "100%"
    },
    to: {
      width: "0%"
    }
  },
  container: {
    position: "relative",
    height: "100%"
  },
  items: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "1%",
    height: "100%",
    position: "relative",
    opacity: 0,
    transition: theme.transitions.create(["opacity"], {
      easing: theme.transitions.easing.sharp,
      duration: ".3s"
    })
  },
  itemsShow: {
    opacity: 1
  },
  linearColorPrimary: {
    backgroundColor: "rgba(255,255,255,0.25)"
  },
  linearBarColorPrimary: {
    backgroundColor: "#fff"
  },
  timer: {
    position: "absolute",
    left: 0,
    bottom: 0,
    borderBottom: "1px solid rgba(255, 255, 255, 0.5)",
    animationName: "timerAnimation",
    animationTimingFunction: "ease-out",
    animationIterationCount: "infinite",
    opacity: 1,
    transition: theme.transitions.create(["opacity"], {
      easing: theme.transitions.easing.sharp,
      duration: ".3s"
    }),
    "&:after": {
      content: "''",
      position: "absolute",
      right: 0,
      bottom: 0,
      width: 10,
      boxShadow: "5px 0px 14px 7px rgba(255, 255, 255, 0.2)"
    }
  },
  timeHide: {
    opacity: 0
  },
  raffleWinner: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
    padding: "1%",
    opacity: 0,
    transition: theme.transitions.create(["opacity"], {
      easing: theme.transitions.easing.sharp,
      duration: ".3s"
    })
  },
  raffleWinnerShow: {
    opacity: 1
  },
  raffleWinnerNameArea: {
    textAlign: "left",
    width: "50%",
    paddingLeft: 30,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  raffleWinnerName: {
    color: "white",
    fontWeight: "400",
    fontFamily: "Oswald",
    fontSize: "6.2rem",
    lineHeight: 1.2,
    fontStyle: "italic"
  },
  raffleWinnerItem: {
    color: "white",
    fontSize: "3rem",
    lineHeight: 1.2,
    fontWeight: "100"
  },
  winnerText: {
    color: "white",
    opacity: "0.2",
    fontSize: "9rem",
    fontFamily: "Oswald",
    fontWeight: "400",
    fontStyle: "italic",
    textAlign: "right",
    paddingRight: 64,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/ItemRotator/styles.js